<template>
  <form-wrapper :validator="$v.item">
    <div class="row">
      <div class="col-md-9">
        <b-form-group
          name="osobitne_zaznamy"
          :label="$t('message.menuOsobitne')">
          <template slot-scope="{ attrs, listeners }">
            <b-form-textarea
              class="alignL"
              v-bind="attrs"
              v-model="item.osobitne_zaznamy"
              v-on="listeners"/>
          </template>
        </b-form-group>
      </div>
    </div>

    <b-button
      class="btn-primary"
      @click="save">{{ $t('message.lblSave') }}</b-button>

  </form-wrapper>
</template>

<script>
import { minLength } from 'vuelidate/lib/validators';
import bFormGroup from '@/components/form-group-col6';
import restEditor from '@/mixins/restEditor';

export default {
  components: {
    bFormGroup,
  },
  mixins: [restEditor],

  data() {
    return {
      item: {
        osobitne_zaznamy: null,
      },
    };
  },

  validations: {
    item: {
      osobitne_zaznamy: {
        minLength: minLength(5),
      },
    },
  },

  methods: {
    async processGet() {
      this.item = await this.restDataSource.getData(this.$route.params.userId, 'notes');
    },
    async processSave() {
      await this.restDataSource.updateData(this.item, 'notes');
    },
  },
};
</script>
